module.exports = __webpack_public_path__ + "img/autosense-compatibility-check-round-large.2be9eb00.png";